interface Window {
  __ucpGtmId: string | undefined;
  google_tag_manager: { [key: string]: unknown } | undefined;
}

(function () {
  const gtmId = window.__ucpGtmId;
  if (!gtmId) return;

  const gtmUrl = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  var reportUrl = "/api/client-monitor/gtm-blocked";
  var reported = false;

  function send(data: object): void {
    if (reported) return;
    reported = true;
    var blob = new Blob([JSON.stringify(data)], { type: "application/json" });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(reportUrl, blob);
    } else {
      fetch(reportUrl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      });
    }
  }

  function buildPayload(reason: string, duration: number | null): object {
    return {
      gtmId: gtmId,
      url: location.href,
      ts: new Date().toISOString(),
      reason: reason,
      duration: duration,
    };
  }

  if (window.PerformanceObserver) {
    var observer = new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.name.indexOf(gtmUrl) !== -1) {
          observer.disconnect();
          if (e.duration === 0) {
            // duration can be 0 in Chrome for a resource that actually loaded (e.g. served
            // from cache) — defer one tick so a genuinely-loaded GTM has a chance to
            // register itself before we conclude the request was blocked.
            window.setTimeout(function () {
              if (!(window.google_tag_manager && window.google_tag_manager[gtmId])) {
                send(buildPayload("resource_blocked", 0));
              }
            }, 0);
          }
          return;
        }
      }
    });
    observer.observe({ type: "resource", buffered: true });
  }

  window.addEventListener(
    "pagehide",
    function () {
      if (
        !reported &&
        !(window.google_tag_manager && window.google_tag_manager[gtmId])
      ) {
        send(buildPayload("not_loaded", null));
      }
    },
    { passive: true },
  );
})();
